export const AdminUserActionTypes = {
  SET_ADMIN_USERS: 'SET_ADMIN_USERS'
};
